<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      type="bar"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name),
        tickPlacement: 'between'
      }"
      :stacked="true"
      :colors="[ '#ff0000', '#ff6666', '#ff9999', '#1affb2', '#00e396', '#00b377']"
      :fill="{ opacity: [1, 1, 1, 1, 1, 1]}"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.accelerations_and_decelerations') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.accelerations_and_decelerations') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'AccelerationsDecelerationsChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('CAPGCSDCB13EG2'), type: 'bar', id: 'decel_less_4', label: this.$t('chart_legends.deceleration_less_-4') },
        { key: addAggregation('UXDCB13'), type: 'bar', id: 'decel_less_3', label: this.$t('chart_legends.deceleration_less_-3') },
        { key: addAggregation('UXDCB14'), type: 'bar', id: 'decel_less_2', label: this.$t('chart_legends.deceleration_less_-2') },
        { key: addAggregation('UXACB58'), type: 'bar', id: 'accel_more_2', label: this.$t('chart_legends.accelerations_more_2') },
        { key: addAggregation('UXACB68'), type: 'bar', id: 'accel_more_3', label: this.$t('chart_legends.accelerations_more_3') },
        { key: addAggregation('CAPGCSACB13EG2'), type: 'bar', id: 'accel_more_4', label: this.$t('chart_legends.accelerations_more_4') }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '20%'
        },
        {
          text: this.$t('chart_legends.deceleration_less_-4'),
          value: valuePrefix + addAggregation('CAPGCSDCB13EG2'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('chart_legends.deceleration_less_-3'),
          value: valuePrefix + addAggregation('UXDCB13'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('chart_legends.deceleration_less_-2'),
          value: valuePrefix + addAggregation('UXDCB14'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('chart_legends.accelerations_more_2'),
          value: valuePrefix + addAggregation('UXACB58'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('chart_legends.accelerations_more_3'),
          value: valuePrefix + addAggregation('UXACB68'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('chart_legends.accelerations_more_4'),
          value: valuePrefix + addAggregation('CAPGCSACB13EG2'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
